// CustomNodeComponent.js

import React, { useContext } from 'react';
import { useReactFlow } from 'reactflow';
import { NodeHandlerContext } from './NodeHandlerContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { Handle } from 'reactflow';

const CustomNodeComponent = ({ id, data }) => {
  const { getEdges } = useReactFlow();
  const onAddChildNode = useContext(NodeHandlerContext);

  const hasOutgoing = getEdges().some(edge => edge.source === id);
  const isEndNode = data.label === 'End flow';
  const isStartNode = data.label === 'Start';

  const showAddButton = !hasOutgoing && !isEndNode && data.showAdd !== false;

  return (
    <div
      className={`
        relative
        ${isStartNode
          ? 'bg-blue-600 text-white rounded-full w-16 h-16 flex items-center justify-center'
          : isEndNode
          ? 'bg-white font-bold text-black px-4 py-2 rounded border border-gray-300 flex items-center justify-center min-w-[120px]'
          : 'bg-white border border-gray-300 shadow rounded flex items-center gap-2 px-4 py-2 min-w-[180px] max-w-[240px]'
        }
        text-sm
      `}
    >
      {/* Start Node Icon */}
      {isStartNode && data.icon && (
        <FontAwesomeIcon icon={data.icon} className="text-white text-lg" />
      )}

      {/* End Node Label */}
      {isEndNode && (
        <span className="whitespace-nowrap">{data.label}</span>
      )}

      {/* Normal Node: Icon + Label */}
      {!isStartNode && !isEndNode && (
        <div className="flex items-center gap-2 leading-none">
          {data.icon && (
            <span
              className={`inline-flex items-center justify-center w-6 h-6 rounded-full
                ${data.badgeBg || 'bg-blue-100'}`}
            >
              <FontAwesomeIcon
                icon={data.icon}
                className={`${data.iconClass || 'text-blue-600'} text-[13px]`}
              />
            </span>
          )}
          <span className="whitespace-nowrap">{data.label}</span>
        </div>
      )}


      {/* + Button centered below */}
      {showAddButton && (
        <div
          onClick={(e) => {
            e.stopPropagation(); // Prevent triggering node click!
            onAddChildNode?.(id);
          }}
          className="absolute left-1/2 -translate-x-1/2 top-full mt-1 w-6 h-6 flex items-center justify-center bg-white border border-gray-300 rounded-full shadow cursor-pointer hover:bg-blue-50 z-[10]"
        >
          <FontAwesomeIcon icon={faPlus} className="text-blue-600 text-xs" />
        </div>
      )}
    
    <Handle type="target" position="top" />
    <Handle type="source" position="bottom" />
    
    </div>
    
  );
};

export default CustomNodeComponent;
